module.exports = __webpack_public_path__ + "img/map.911aa6d3.png";